import React from "react";
import {withTranslation} from "react-i18next";
import RoutePath from "../../resource/RoutePath";
import { Link } from 'react-router-dom';

class MGroupsComp  extends React.Component {
	constructor(props) {
        super(props);
		this.state = {
		};
	}
	render() {
		const {t} = this.props;
		return (
			<div className="content-wrap sub-content">
				<div className="visual-wrap">
					<div className="img">
						<img src="https://asset.981park.com/www/common/mweb/img/sub/groups/groups_main.png" alt="ABOUT GROUPS"/>
					</div>
					<div className="inner">
						<div className="con">
							<div className="text-wrap color1">
								<p className="s-text typo1">ABOUT GROUPS</p>
								<p className="m-text">{t('Ticket_sub_c9_2')}</p>
							</div>	
						</div>	
					</div>
				</div>
				<div className="card-list-wrap">
					<div className="card-wrap">
						<div className="inner">
							<div className="con">
								<div className="text-wrap">
									<p className="s-text typo1">GROUPS INFORMATION</p>
									<p className="m-text">{t('Groups_info_desc')}</p>
								</div>							
								<div className="card-list">
									<div className="card">
										<div className="card-inner">
											<img src="https://asset.981park.com/www/common/mweb/img/sub/groups/groups_sub_activity.png" alt="ACTIVITY" className="img img-1"/>
											<p className="text typo1 color1">GROUP <br/> ACTIVITIES</p>
											<div className="label-txt"><span>{t('Groups_sub1_title')}</span></div>
											<div className="button-wrap">
												<Link to={`/`+RoutePath.GROUP} className="link-more"><span className="blind">more</span></Link>
											</div>
										</div>						
									</div>
									<div className="card">
										<div className="card-inner">
											<img src="https://asset.981park.com/www/common/mweb/img/sub/groups/groups_sub_rental.png" alt="RENTAL" className="img img-1"/>
											<p className="text typo1 color1">VENUE <br/> RENTAL</p>
											<div className="label-txt"><span>{t('Groups_sub2_title')}</span></div>
											<div className="button-wrap">
												<Link to={`/`+RoutePath.VENUE} className="link-more"><span className="blind">more</span></Link>
											</div>
										</div>					
									</div>
								</div>
							</div>
						</div>					
					</div>
				</div>
			</div>
		);
	}
}
export default withTranslation()(MGroupsComp);
